module.exports = __webpack_public_path__ + "img/part.b74b8a66.png";